import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ChatStyles from '../../Chat.module.css';

const SelectedUser = ({ data, requestVideoCallToSelectedUser }) => {
  const { t } = useTranslation();
  const {
    chatUserLoading,
    checkOnlineAndGetData,
    checkOnline,
    selectedNewUser,
    selectedUser,
    setShowSecurityKey,
    showSecurityKey,
    setVideoNotesModal,
    setGroupName,
    socket
  } = data;

  const [lastSeenTime, setLastSeenTime] = React.useState(0);
  const [subMenu, setSubMenu] = React.useState(false);
  const [isTyping, setIsTyping] = React.useState(false);
  const typingTimeoutRef = React.useRef(null);

  React.useEffect(() => {
    if (
      selectedNewUser &&
      Object.keys(selectedNewUser).length > 0 &&
      selectedNewUser.lastSeenTime &&
      selectedNewUser.lastSeenTime > 0
    ) {
      setLastSeenTime(selectedNewUser.lastSeenTime);
    } else if (
      selectedNewUser &&
      Object.keys(selectedNewUser).length === 0 &&
      selectedUser &&
      selectedUser.lastSeenTime &&
      selectedUser.lastSeenTime > 0
    ) {
      setLastSeenTime(selectedUser.lastSeenTime);
    }
  }, [selectedNewUser, selectedUser]);

  // Listen for typing indicator via socket
  React.useEffect(() => {
    if (!socket || !selectedUser?._id) return;

    const handleTyping = (data) => {
      if (data?.userId === selectedUser._id) {
        setIsTyping(true);
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
        typingTimeoutRef.current = setTimeout(() => setIsTyping(false), 3000);
      }
    };

    socket.on('userTyping', handleTyping);
    return () => {
      socket.off('userTyping', handleTyping);
      if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
    };
  }, [socket, selectedUser?._id]);

  return (
    <div className={ChatStyles.chatBox_user}>
      <div className={ChatStyles.chatBox_user_data}>
        <div className={ChatStyles.chatLists_user_imageBox}>
          <img
            src='/assets/indviual.png'
            alt='User'
            className={ChatStyles.chatLists_user_image}
          />
          {checkOnline(selectedUser._id) ? (
            <div className={ChatStyles.chatLists_user_active} />
          ) : (
            <div className={ChatStyles.chatLists_user_deactive} />
          )}
        </div>
        <div>
          <h3 className={ChatStyles.chatLists_user_name}>
            {selectedUser && selectedUser.name ? selectedUser.name : ''}
          </h3>
          <p className={ChatStyles.chatLists_user_msg} style={{maxWidth:'20rem'}}>
            {isTyping ? (
              <span style={{ color: '#7c3aed', fontStyle: 'italic' }}>{t('screens.chat.typing')}</span>
            ) : checkOnline(selectedUser._id) ? (
              t('screens.chat.online')
            ) : lastSeenTime > 0 ? (
              <span>
                {t('screens.chat.lastSeenPrefix')}
                {new Date(lastSeenTime).getDate() ===
                  new Date(Date.now()).getDate()
                  ? t('screens.chat.lastSeenTodayLabel')
                  : new Date(lastSeenTime).getDate() ===
                    new Date(Date.now()).getDate() - 1
                    ? t('screens.chat.lastSeenYesterdayLabel')
                    : new Date(lastSeenTime).toLocaleDateString()}
                {t('screens.chat.lastSeenAt')}
                {new Date(lastSeenTime)
                  .toLocaleTimeString()
                  .replace(/(.*)\D\d+/, '$1')}
              </span>
            ) : (
              t('screens.chat.offline')
            )}
          </p>
        </div>
      </div>

      {!chatUserLoading && (
        <div className={ChatStyles.chatBox_user_right_container}>
          {checkOnlineAndGetData(selectedUser._id) ? (
            <button
              onClick={() => requestVideoCallToSelectedUser(selectedUser)}
              className={ChatStyles.video_call_button}
              title={t('screens.chat.startVideoCall')}
            >
              <svg>
                <use xlinkHref={`/assets/sprite.svg#icon-video-call`} />
              </svg>
            </button>
          ) : (
            <div className={ChatStyles.video_call_button_disabled} title={t('screens.chat.userOffline')}>
              <svg>
                <use xlinkHref={`/assets/sprite.svg#icon-video-call`} />
              </svg>
            </div>
          )}

          {/* <div
            className='dropdown'
            onMouseOver={() => setSubMenu(!subMenu)}
            onMouseOut={() => setSubMenu(!subMenu)}
          >
            <div className='dropdown-a'>
              <svg>
                <use xlinkHref={`/assets/sprite.svg#icon-three_dots`} />
              </svg>
            </div>
            <input
              type='checkbox'
              checked={subMenu}
              onChange={() => {}}
            />
            <div className='dropdown-c'>
              <ul style={{ width: '15rem' }}>
                <li
                  style={{
                    maxHeight: '50vh',
                    overflowY: 'auto',
                  }}
                >
                  <button
                    className='dropdown_link_btn dropdown_link'
                    onClick={() => setShowSecurityKey(!showSecurityKey)}
                  >
                    Security key
                  </button>
                  <button
                    className='dropdown_link_btn dropdown_link'
                    onClick={() => setVideoNotesModal(true)}
                  >
                    Video Notes
                  </button>
                </li>
              </ul>
            </div>
          </div> */}
        </div>
      )}
    </div>
  );
};

export default SelectedUser;
